import * as React from 'react';
import {ContainerLink} from './styles';

interface LinkProps {
  children: React.ReactNode;
  fontColor?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  textAlign?: string;
  href?: string;
  onClick?: any;
}

const Link: React.FC<LinkProps> = ({
  children,
  fontColor,
  fontSize,
  fontWeight,
  lineHeight,
  textAlign,
  href,
  onClick,
}) => {
  return (
    <ContainerLink
      onClick={onClick}
      href={href}
      fontColor={fontColor}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      textAlign={textAlign}>
      {children}
    </ContainerLink>
  );
};

export default Link;
